import { useParams } from 'react-router-dom'
import {
  AppFeatures,
  useStaffGetFeatureToggles,
} from '@urbanx/agx.agencies.client'

const useFeatureToggles = (): {
  featureToggles?: AppFeatures
  isLoading: boolean
} => {
  const { campaignId } = useParams()

  const { data: featureToggles, isPending } = useStaffGetFeatureToggles(
    campaignId || '',
    !!campaignId
  )

  return {
    featureToggles,
    isLoading: isPending,
  }
}

export default useFeatureToggles
